import {BackEndService} from "../../utils/BackEndService";
import {userService} from "./UserService";
import {activityEventType} from "./models/UserActivityTypes";

class UserEventController {

  get activity() {
    return userService.user.userActivityData
  }

  public newActivity(eventType: activityEventType, playableId: number | null, playableType : string | null, additionalData: object){
    BackEndService.sendPostRequest("user/new-activity",
      {
        'event_type' : eventType,
        'playable_id' : playableId,
        'playable_type' : playableType,
        'additional_data' : JSON.stringify(additionalData),
        'created_at' : (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toTimeString().split(' ')[0]
      }).then((response)=> {
      response.content.forEach((event: any)=>{
        if(event.score_variation === 0){
          return;
        }
        this.activity.activityScore += event.score_variation
        this.activity.maxScore = Math.max(this.activity.activityScore, this.activity.maxScore)
        this.activity.activityHistory.push(event)

        if(this.activity.activityHistoryByDay.length > 0 && this.activity.activityHistoryByDay[this.activity.activityHistoryByDay.length - 1].created_at === event.created_at.split(" ")[0]){
          this.activity.activityHistoryByDay[this.activity.activityHistoryByDay.length - 1].score_variation += event.score_variation
        }
        else {
          this.activity.activityHistoryByDay.push({score_variation: event.score_variation, created_at: event.created_at.split(" ")[0]})
        }
        if(this.activity.activityHistoryByWeek.length > 0 && this.activity.activityHistoryByWeek[this.activity.activityHistoryByWeek.length - 1].created_at === event.created_at.split(" ")[0]){
          this.activity.activityHistoryByWeek[this.activity.activityHistoryByWeek.length - 1].score_variation += event.score_variation
        }
        else {
          this.activity.activityHistoryByWeek.push({score_variation: event.score_variation, created_at: event.created_at.split(" ")[0]})
        }

        switch (event.event_type) {
          case 'COMPLETE_CHALLENGE':
            this.activity.eventCounts.challenges += 1
            break;
          case 'COMPLETE_MODULE':
            this.activity.eventCounts.modules += 1
            break;
          case 'COMPLETE_PIECE':
            this.activity.eventCounts.pieces += 1
            break;
          case 'CONNECTION':
            this.activity.eventCounts.connections += 1
            this.activity.lastConnection = new Date().toISOString()
            break;
        }
      })
    })
  }

  public getActivityScoreAt(date: number = Date.now()): number {
    let score = 0;
    for (const event of this.activity.activityHistoryByDay) {
      const eventTimestamp = new Date(event.created_at).getTime();
      if (eventTimestamp <= date) {
        score += event.score_variation;
      }
      else {
        break;
      }
    }
    return score;
  }

}

export const userEventController = new UserEventController()
